import { InputBase } from 'shared/ui/Input';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

import type { Field, KeysStore, MetaData } from './useIntegrationFields';
import { isFieldWithMeta } from './useIntegrationFields';

export function getIntegrationFieldsFromArray(formFields: IntegrationFieldsListForm['fields']) {
  return formFields.reduce((prev, curr) => ({ ...prev, [curr.key]: curr.value }), {});
}

export interface IntegrationFieldsListForm {
  fields: Field[];
}

interface IntegrationFieldsListProps {
  fields: KeysStore;
  errors: Record<number, string>;
  append: (field: Field) => void;
  remove: (fieldId: number) => void;
  onChange: (idx: number, key: string, value: string) => void;
}

const getBgColor = (field: Field | (Field & MetaData)) => {
  if (isFieldWithMeta(field)) {
    if (field.deleted && field.touched) {
      return '!bg-red-50';
    }

    if (!field.deleted && field.touched) {
      return '!bg-deep-green-50';
    }

    return '';
  }

  return '';
};

export function IntegrationFieldsList({ fields, remove, append, onChange, errors }: IntegrationFieldsListProps) {
  return (
    <>
      <div>
        {fields.map((field, index) => (
          <div
            key={index}
            className="mb-2 flex gap-2 last:!mb-0"
          >
            <InputBase
              className="flex-1"
              inputClassName={getBgColor(field)}
              title="Key"
              value={field.key}
              error={errors[index]}
              attributes={{
                autoComplete: 'off',
              }}
              onChange={(e) => {
                onChange(index, e.target.value, field.value);
              }}
              {...getDataAutoTestAttributes([`input-integration-key-${index + 1}`])}
            />
            <InputBase
              className="mr-2 flex-1"
              inputClassName={getBgColor(field)}
              value={field.value}
              title="Value"
              attributes={{
                autoComplete: 'off',
              }}
              onChange={(e) => {
                onChange(index, field.key, e.target.value);
              }}
              {...getDataAutoTestAttributes([`input-integration-value-${index + 1}`])}
            />
            <button
              className="mt-4 outline-none"
              type="button"
              onClick={() => remove(index)}
            >
              <MaterialIcon className="cursor-pointer text-[16px] text-deep-blue-500">delete_outline</MaterialIcon>
            </button>
          </div>
        ))}
      </div>
      <div className="ml-4">
        <button
          type="button"
          className="mt-6 inline-flex cursor-pointer select-none items-center"
          onClick={() => append({ key: '', value: '' })}
        >
          <MaterialIcon className="mr-2 text-[20px] text-deep-blue-500">add_circle_outline</MaterialIcon>
          <div className="text-sm font-semibold text-deep-blue-500">Add new parameter</div>
        </button>
      </div>
    </>
  );
}
